import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { createContext } from 'react';
export const StyleContext = createContext();
export const StyleProvider = ({ initialStyle, children }) => (_jsx(StyleContext.Provider, { value: initialStyle, children: children }));
StyleProvider.propTypes = {
    initialStyle: PropTypes.object.isRequired,
    children: PropTypes.any
};
